"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const path = __importStar(require("path"));
const utils_1 = require("./utils");
const triple_beam_1 = require("triple-beam");
const exception_formatter_1 = __importDefault(require("exception-formatter"));
const INDENT = '    ';
const SKIP_VALUES = ['level', 'message', '@timestamp', 'name'];
/**
 * Debug formatter intended for logging to console.  This is roughly a port
 * of bunyan-debug-stream.
 */
class DebugFormat {
    constructor(options = {}) {
        this.options = options;
        const scriptName = process.argv[1] || process.argv[0];
        this._processName = scriptName
            ? path.basename(scriptName, path.extname(scriptName))
            : '';
        const levels = options.levels || triple_beam_1.configs.npm.levels;
        const levelNames = Object.keys(levels);
        this._maxLevelLength = Math.max.apply(Math, levelNames.map(s => s.length));
        this._colors = options.colors === false ? false
            : options.colors || triple_beam_1.configs.npm.colors;
        this._basepath = process.cwd();
    }
    _getPrefix(info, options) {
        const processName = options.processName || this._processName;
        const loggerName = info.name ? `:${info.name}` : '';
        const date = utils_1.dateToString(new Date());
        const level = info[triple_beam_1.LEVEL] || info.level || 'info';
        const pid = process.pid;
        // If `info.level` is defined, use it for the level label - just in
        // case some previous formatter has colorized it or done something
        // else exciting.
        const levelLabel = utils_1.rpad(`${(info.level || level).toUpperCase()}:`, this._maxLevelLength + 1);
        return `${date} ${processName}${loggerName}[${pid}] ${levelLabel}`;
    }
    _getValues(info, options) {
        const values = [];
        for (const key of Object.keys(info)) {
            // Skip fields we don't care about
            if (SKIP_VALUES.includes(key)) {
                continue;
            }
            const value = info[key];
            if (value instanceof Error) {
                values.push(`${INDENT}${key}: ${this._formatError(value, options)}`);
            }
            else {
                const valueString = value != null && JSON.stringify(value);
                if (valueString) {
                    // Make sure value isn't too long.
                    const cols = ('terminalWidth' in this.options)
                        ? this.options.terminalWidth
                        : process.stdout.columns || 80;
                    let line = `${INDENT}${key}: ${valueString}`;
                    if (cols && line.length >= cols) {
                        line = line.slice(0, cols - 3) + '...';
                    }
                    values.push(line);
                }
            }
        }
        return values;
    }
    _formatError(err, options) {
        const formatOptions = {
            format: options.colors ? 'ansi' : 'ascii',
            colors: false,
            basepath: options.basePath || this._basepath,
            maxLines: options.maxExceptionLines
        };
        const formatted = exception_formatter_1.default(err, formatOptions);
        return formatted.split('\n').join(`\n${INDENT}`);
    }
    transform(info, options) {
        const level = info[triple_beam_1.LEVEL] || info.level || 'info';
        let prefix = this._getPrefix(info, options);
        let message = info.message;
        let valuesString = this._getValues(info, options).join('\n');
        const colors = options.colors === false ? false
            : options.colors || this._colors;
        if (colors && colors[level]) {
            const colorizePrefix = !!options.colorizePrefix;
            const colorizeMessage = (!('colorizeMessage' in options)) || options.colorizeMessage;
            const colorizeValues = (!('colorizeValues' in options)) || options.colorizeValues;
            if (colorizePrefix) {
                prefix = utils_1.applyColors(prefix, colors[level]);
            }
            if (colorizeMessage) {
                message = utils_1.applyColors(message, colors[level]);
            }
            if (colorizeValues && valuesString) {
                valuesString = utils_1.applyColors(valuesString, colors[level]);
            }
        }
        let result = `${prefix} ${message}`;
        if (valuesString.length) {
            result = `${result}\n${valuesString}`;
        }
        info[triple_beam_1.MESSAGE] = result;
        return info;
    }
}
exports.DebugFormat = DebugFormat;
function createDebugFormat(options = {}) {
    return new DebugFormat(options);
}
exports.default = createDebugFormat;
//
// Attach the Colorizer for registration purposes
//
exports.Format = DebugFormat; // tslint:disable-line
//# sourceMappingURL=index.js.map